import React, { useEffect, useState } from "react";
import AdminSidebar from './AdminSidebar'
import axios from "axios";
import iziToast from 'izitoast';
import { useAuth } from '../../AuthContext';

const LandingPageQuery = () => {
  const { apipath } = useAuth();
  const [landingQueryData, setlandingQueryData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Function to format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '-';

    try {
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) return '-';

      // Format date as DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      // Format time as HH:MM AM/PM
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const formattedHours = String(hours).padStart(2, '0');

      return `${day}/${month}/${year}, ${formattedHours}:${minutes} ${ampm}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '-';
    }
  };

  // Function to fetch landingQuery data
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apipath}/landingQuery/get`)
      console.log("Fetched landing queries:", response.data.allQuery);
      setlandingQueryData(response.data.allQuery || []);
    } catch (error) {
      console.error('Error fetching landing queries:', error);
      iziToast.error({
        message: "Failed to fetch queries",
        position: "topCenter",
      });
    }
  };

  //  Function to handle landing query deletion
  const handleDelete = async (queryId) => {
    try {
      const response = await axios.delete(`${apipath}/landingQuery/delete`, {
        data: { queryId }
      });

      if (response.status === 200) {
        // Update the state to remove the deleted query from the UI
        setlandingQueryData(prevquery => prevquery.filter(query => query._id !== queryId));

        // Show success notification
        iziToast.success({
          message: "Query deleted successfully",
          position: "topCenter",
        });

      } else {
        // Show error notification if deletion failed
        iziToast.error({
          message: "Query deletion failed",
          position: "topCenter",
        });
      }
    } catch (error) {
      console.error('Error deleting query:', error);
      // Show error notification if an error occurred
      iziToast.error({
        message: "An error occurred while deleting the query",
        position: "topCenter",
      });
    }
  };

  // Filter queries based on search - safely handle potentially missing fields from old data
  const filteredQueries = landingQueryData.filter(query => {
    if (!searchQuery.trim()) return true; // Show all when no search query

    const searchLower = searchQuery.toLowerCase();
    const nameMatch = query.name && query.name.toLowerCase().includes(searchLower);
    const phoneMatch = query.phoneNo && query.phoneNo.includes(searchQuery);
    const emailMatch = query.email && query.email.toLowerCase().includes(searchLower);

    return nameMatch || phoneMatch || emailMatch;
  });


  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <AdminSidebar />
      <div className="home">
        <div className="toggle-sidebar" style={{ display: "none" }}>
          <i className="bi bi-menu"></i>
        </div>
        <div className="dashboard">
          <div className="dashboard-header">
            <h1>Landing Page Query</h1>
          </div>

          <div className="container-fluid">
            <div className='filter-flex'>
              <div class="input-group search-group">
                <div class="input-group-prepend search-prepend">
                  <span class="input-group-text search-text" id="basic-addon1">
                    <i className="bi bi-search"></i>
                  </span>
                </div>
                <input
                  type="text"
                  class="form-control search-control"
                  placeholder="Search by name, phone, or email"
                  aria-label="Search"
                  aria-describedby="basic-addon1"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
            <div className="row foot-tablerow">
              <div className="col-lg-11 maintable-column">
                <div className="container mt-4">
                  <table id="datatable" className="table">
                    <thead>
                      <tr className="tr1">
                        <th>S.No.</th>
                        <th>Submission Date</th>
                        <th>Name</th>
                        <th>Phone No.</th>
                        <th>Email</th>
                        <th>City</th>
                        <th>Product</th>
                        <th>Pieces</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredQueries.length > 0 ? (
                        filteredQueries.map((lpQuery, index) => (
                          <tr key={lpQuery._id}>
                            <td>{index + 1}</td>
                            <td>{formatDate(lpQuery.createdAt)}</td>
                            <td>{lpQuery.name || '-'}</td>
                            <td>{lpQuery.phoneNo || '-'}</td>
                            <td>{lpQuery.email || '-'}</td>
                            <td>{lpQuery.address || '-'}</td>
                            <td>{lpQuery.product || '-'}</td>
                            <td>{lpQuery.pieces || '-'}</td>
                            <td>
                              <button className="table-btn" onClick={() => handleDelete(lpQuery._id)}>
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>
                            {searchQuery ? 'No queries found matching your search' : 'No queries available'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPageQuery;
